<template>
  <div class="oai-ResearchTable_Body">
    <div
      v-for="(row, index) in rows"
      :key="`${row.label}-${index}`"
      class="oai-ResearchTable_Row"
      :class="{
        'oai-ResearchTable_Row-divided': index < rows.length - 1
      }"
    >
      <span class="oai-ResearchTable_Label">{{ row.label }}</span>
      <span class="oai-ResearchTable_Value">{{ row.value }}</span>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'OnboardingAiResearchTableBody'
})

defineProps({
  rows: {
    type: Array,
    required: true
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/onboarding-ai-step';

.oai-ResearchTable_Body {
  padding: 12px 0;
}

.oai-ResearchTable_Row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 8px 16px;
  font-size: $fs-12;
  line-height: 18px;

  &-divided {
    border-bottom: 1px solid $oai-divider;
  }
}

.oai-ResearchTable_Label {
  width: 150px;
  font-weight: fw('bold');
  color: $oai-text-secondary;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
  white-space: pre-line;
}

.oai-ResearchTable_Value {
  flex: 1;
  min-width: 0;
  font-weight: fw('regular');
  color: $oai-text-secondary;
  word-break: break-word;
  white-space: pre-line;
}
</style>
